import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pagination: { page: 0, pageSize: 15 },
  sortModel: [{ field: "created", sort: "desc" }],
  searchText: "",
};

const modulesSlice = createSlice({
  name: "modules",
  initialState,
  reducers: {
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setSortModel: (state, action) => {
      state.sortModel = action.payload;
    },
    setSearchText: (state, action) => {
      state.searchText = action.payload;
    },
    resetPage: state => {
          state.pagination.page = 0;
        },
    resetModulesState: state => Object.assign(state, initialState),
  },
});

export const { setPagination, setSortModel, setSearchText, resetModulesState,resetPage } = modulesSlice.actions;
export default modulesSlice.reducer;
